export default __webpack_public_path__ + "media/images/_MG_1125_web-fae8af5ec496a4b7364a4945e47fc71b.png";